/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminClaimReservationRequest,
  ClaimCenterBookableScheduleException,
  ClaimCenterBookableSchedules,
  ClaimCenterBookables,
  ClaimCenterScheduleException,
  ClaimCenterScheduleExceptions,
  ClaimCenterScheduleExceptionsForRange,
  ClaimCentersWithBookables,
  ClaimReservation,
  ClaimReservationAvailability,
  ClaimReservationResponse,
  ClaimReservations,
  EditClaimReservationRequest,
  ErrorResponse,
  PageClaimReservationResponse,
  ResendClaimFormNotificationRequest,
  ResendClaimFormNotificationResponse,
  ScheduleClaimCenterBookableRequest,
  ScheduleExceptionTemplate,
  UnscheduleBookableRequest,
  UnscheduleBookableResponse,
  UnschedulePreviewResponse,
} from '../models/index';
import {
    AdminClaimReservationRequestFromJSON,
    AdminClaimReservationRequestToJSON,
    ClaimCenterBookableScheduleExceptionFromJSON,
    ClaimCenterBookableScheduleExceptionToJSON,
    ClaimCenterBookableSchedulesFromJSON,
    ClaimCenterBookableSchedulesToJSON,
    ClaimCenterBookablesFromJSON,
    ClaimCenterBookablesToJSON,
    ClaimCenterScheduleExceptionFromJSON,
    ClaimCenterScheduleExceptionToJSON,
    ClaimCenterScheduleExceptionsFromJSON,
    ClaimCenterScheduleExceptionsToJSON,
    ClaimCenterScheduleExceptionsForRangeFromJSON,
    ClaimCenterScheduleExceptionsForRangeToJSON,
    ClaimCentersWithBookablesFromJSON,
    ClaimCentersWithBookablesToJSON,
    ClaimReservationFromJSON,
    ClaimReservationToJSON,
    ClaimReservationAvailabilityFromJSON,
    ClaimReservationAvailabilityToJSON,
    ClaimReservationResponseFromJSON,
    ClaimReservationResponseToJSON,
    ClaimReservationsFromJSON,
    ClaimReservationsToJSON,
    EditClaimReservationRequestFromJSON,
    EditClaimReservationRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    PageClaimReservationResponseFromJSON,
    PageClaimReservationResponseToJSON,
    ResendClaimFormNotificationRequestFromJSON,
    ResendClaimFormNotificationRequestToJSON,
    ResendClaimFormNotificationResponseFromJSON,
    ResendClaimFormNotificationResponseToJSON,
    ScheduleClaimCenterBookableRequestFromJSON,
    ScheduleClaimCenterBookableRequestToJSON,
    ScheduleExceptionTemplateFromJSON,
    ScheduleExceptionTemplateToJSON,
    UnscheduleBookableRequestFromJSON,
    UnscheduleBookableRequestToJSON,
    UnscheduleBookableResponseFromJSON,
    UnscheduleBookableResponseToJSON,
    UnschedulePreviewResponseFromJSON,
    UnschedulePreviewResponseToJSON,
} from '../models/index';

export interface ClearClaimReservationCheckedInRequest {
    customerId: string;
    claimReservationId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface ClearClaimReservationNoShowRequest {
    customerId: string;
    claimReservationId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface CreateClaimCenterBookableExceptionRequest {
    claimCenterId: string;
    bookableId: string;
    customerId: string;
    scheduleExceptionTemplate: ScheduleExceptionTemplate;
    xClientID?: string;
    xRequestID?: string;
}

export interface CreateClaimCenterExceptionRequest {
    claimCenterId: string;
    customerId: string;
    scheduleExceptionTemplate: ScheduleExceptionTemplate;
    xClientID?: string;
    xRequestID?: string;
}

export interface CreateClaimCenterReservationRequest {
    claimCenterId: string;
    customerId: string;
    adminClaimReservationRequest: AdminClaimReservationRequest;
    xClientID?: string;
    xRequestID?: string;
}

export interface DeleteClaimReservationRequest {
    customerId: string;
    claimReservationId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface DeleteScheduleExceptionRequest {
    claimCenterId: string;
    exceptionId: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface EditClaimReservationOperationRequest {
    customerId: string;
    claimReservationId: string;
    editClaimReservationRequest: EditClaimReservationRequest;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetClaimCenterAvailabilityRequest {
    claimCenterId: string;
    date: string;
    customerId: string;
    durationInMinutes?: number;
    excludeReservationId?: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetClaimCenterBookablesForDateRequest {
    claimCenterId: string;
    date: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetClaimCenterExceptionsForDateRequest {
    claimCenterId: string;
    date: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetClaimCenterExceptionsForRangeRequest {
    localStartDate: string;
    localEndDate: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetClaimCentersRequest {
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetClaimReservationsRequest {
    claimCenterId: string;
    startDate: Date;
    endDate: Date;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetUnschedulePreviewRequest {
    claimCenterId: string;
    bookableId: string;
    localDate: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface ResendClaimFormNotificationOperationRequest {
    customerId: string;
    claimReservationId: string;
    resendClaimFormNotificationRequest: ResendClaimFormNotificationRequest;
    xClientID?: string;
    xRequestID?: string;
}

export interface ScheduleClaimCenterBookableOperationRequest {
    claimCenterId: string;
    customerId: string;
    scheduleClaimCenterBookableRequest: ScheduleClaimCenterBookableRequest;
    xClientID?: string;
    xRequestID?: string;
}

export interface SearchClaimReservationsRequest {
    query: string;
    resultStart: number;
    resultEnd: number;
    customerId: string;
    startDate?: string;
    endDate?: string;
    claimCenterIds?: Array<string>;
    includeCancelled?: boolean;
    xClientID?: string;
    xRequestID?: string;
}

export interface SetClaimReservationCheckedInRequest {
    customerId: string;
    claimReservationId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface SetClaimReservationNoShowRequest {
    customerId: string;
    claimReservationId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface UnscheduleClaimCenterBookableRequest {
    claimCenterId: string;
    bookableId: string;
    customerId: string;
    unscheduleBookableRequest: UnscheduleBookableRequest;
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class ClaimReservationsApi extends runtime.BaseAPI {

    /**
     * Clear checked-in status from a claim reservation
     */
    async clearClaimReservationCheckedInRaw(requestParameters: ClearClaimReservationCheckedInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling clearClaimReservationCheckedIn().'
            );
        }

        if (requestParameters['claimReservationId'] == null) {
            throw new runtime.RequiredError(
                'claimReservationId',
                'Required parameter "claimReservationId" was null or undefined when calling clearClaimReservationCheckedIn().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-reservations/{claimReservationId}/checked-in`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"claimReservationId"}}`, encodeURIComponent(String(requestParameters['claimReservationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Clear checked-in status from a claim reservation
     */
    async clearClaimReservationCheckedIn(requestParameters: ClearClaimReservationCheckedInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.clearClaimReservationCheckedInRaw(requestParameters, initOverrides);
    }

    /**
     * Clear no-show status from a claim reservation
     */
    async clearClaimReservationNoShowRaw(requestParameters: ClearClaimReservationNoShowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling clearClaimReservationNoShow().'
            );
        }

        if (requestParameters['claimReservationId'] == null) {
            throw new runtime.RequiredError(
                'claimReservationId',
                'Required parameter "claimReservationId" was null or undefined when calling clearClaimReservationNoShow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-reservations/{claimReservationId}/no-show`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"claimReservationId"}}`, encodeURIComponent(String(requestParameters['claimReservationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Clear no-show status from a claim reservation
     */
    async clearClaimReservationNoShow(requestParameters: ClearClaimReservationNoShowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.clearClaimReservationNoShowRaw(requestParameters, initOverrides);
    }

    /**
     * Create a schedule exception for a bookable at a claim center
     */
    async createClaimCenterBookableExceptionRaw(requestParameters: CreateClaimCenterBookableExceptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimCenterBookableScheduleException>> {
        if (requestParameters['claimCenterId'] == null) {
            throw new runtime.RequiredError(
                'claimCenterId',
                'Required parameter "claimCenterId" was null or undefined when calling createClaimCenterBookableException().'
            );
        }

        if (requestParameters['bookableId'] == null) {
            throw new runtime.RequiredError(
                'bookableId',
                'Required parameter "bookableId" was null or undefined when calling createClaimCenterBookableException().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling createClaimCenterBookableException().'
            );
        }

        if (requestParameters['scheduleExceptionTemplate'] == null) {
            throw new runtime.RequiredError(
                'scheduleExceptionTemplate',
                'Required parameter "scheduleExceptionTemplate" was null or undefined when calling createClaimCenterBookableException().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:claim-center-exceptions"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-reservations/claim-center/{claimCenterId}/bookable/{bookableId}/exception`;
        urlPath = urlPath.replace(`{${"claimCenterId"}}`, encodeURIComponent(String(requestParameters['claimCenterId'])));
        urlPath = urlPath.replace(`{${"bookableId"}}`, encodeURIComponent(String(requestParameters['bookableId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ScheduleExceptionTemplateToJSON(requestParameters['scheduleExceptionTemplate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimCenterBookableScheduleExceptionFromJSON(jsonValue));
    }

    /**
     * Create a schedule exception for a bookable at a claim center
     */
    async createClaimCenterBookableException(requestParameters: CreateClaimCenterBookableExceptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimCenterBookableScheduleException> {
        const response = await this.createClaimCenterBookableExceptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a schedule exception for a whole claim center.
     */
    async createClaimCenterExceptionRaw(requestParameters: CreateClaimCenterExceptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimCenterScheduleException>> {
        if (requestParameters['claimCenterId'] == null) {
            throw new runtime.RequiredError(
                'claimCenterId',
                'Required parameter "claimCenterId" was null or undefined when calling createClaimCenterException().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling createClaimCenterException().'
            );
        }

        if (requestParameters['scheduleExceptionTemplate'] == null) {
            throw new runtime.RequiredError(
                'scheduleExceptionTemplate',
                'Required parameter "scheduleExceptionTemplate" was null or undefined when calling createClaimCenterException().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:claim-center-exceptions"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-reservations/claim-center/{claimCenterId}/exception`;
        urlPath = urlPath.replace(`{${"claimCenterId"}}`, encodeURIComponent(String(requestParameters['claimCenterId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ScheduleExceptionTemplateToJSON(requestParameters['scheduleExceptionTemplate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimCenterScheduleExceptionFromJSON(jsonValue));
    }

    /**
     * Create a schedule exception for a whole claim center.
     */
    async createClaimCenterException(requestParameters: CreateClaimCenterExceptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimCenterScheduleException> {
        const response = await this.createClaimCenterExceptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a claim center reservation
     */
    async createClaimCenterReservationRaw(requestParameters: CreateClaimCenterReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimReservationResponse>> {
        if (requestParameters['claimCenterId'] == null) {
            throw new runtime.RequiredError(
                'claimCenterId',
                'Required parameter "claimCenterId" was null or undefined when calling createClaimCenterReservation().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling createClaimCenterReservation().'
            );
        }

        if (requestParameters['adminClaimReservationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminClaimReservationRequest',
                'Required parameter "adminClaimReservationRequest" was null or undefined when calling createClaimCenterReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-reservations/claim-center/{claimCenterId}/reservations`;
        urlPath = urlPath.replace(`{${"claimCenterId"}}`, encodeURIComponent(String(requestParameters['claimCenterId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminClaimReservationRequestToJSON(requestParameters['adminClaimReservationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimReservationResponseFromJSON(jsonValue));
    }

    /**
     * Create a claim center reservation
     */
    async createClaimCenterReservation(requestParameters: CreateClaimCenterReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimReservationResponse> {
        const response = await this.createClaimCenterReservationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a claim reservation
     */
    async deleteClaimReservationRaw(requestParameters: DeleteClaimReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling deleteClaimReservation().'
            );
        }

        if (requestParameters['claimReservationId'] == null) {
            throw new runtime.RequiredError(
                'claimReservationId',
                'Required parameter "claimReservationId" was null or undefined when calling deleteClaimReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-reservations/{claimReservationId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"claimReservationId"}}`, encodeURIComponent(String(requestParameters['claimReservationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a claim reservation
     */
    async deleteClaimReservation(requestParameters: DeleteClaimReservationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteClaimReservationRaw(requestParameters, initOverrides);
    }

    /**
     * delete a schedule exception for a bookable or a claim center
     */
    async deleteScheduleExceptionRaw(requestParameters: DeleteScheduleExceptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimCenterId'] == null) {
            throw new runtime.RequiredError(
                'claimCenterId',
                'Required parameter "claimCenterId" was null or undefined when calling deleteScheduleException().'
            );
        }

        if (requestParameters['exceptionId'] == null) {
            throw new runtime.RequiredError(
                'exceptionId',
                'Required parameter "exceptionId" was null or undefined when calling deleteScheduleException().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling deleteScheduleException().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:claim-center-exceptions"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-reservations/claim-center/{claimCenterId}/exception/{exceptionId}`;
        urlPath = urlPath.replace(`{${"claimCenterId"}}`, encodeURIComponent(String(requestParameters['claimCenterId'])));
        urlPath = urlPath.replace(`{${"exceptionId"}}`, encodeURIComponent(String(requestParameters['exceptionId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete a schedule exception for a bookable or a claim center
     */
    async deleteScheduleException(requestParameters: DeleteScheduleExceptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteScheduleExceptionRaw(requestParameters, initOverrides);
    }

    /**
     * Edit a claim reservation
     */
    async editClaimReservationRaw(requestParameters: EditClaimReservationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimReservation>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling editClaimReservation().'
            );
        }

        if (requestParameters['claimReservationId'] == null) {
            throw new runtime.RequiredError(
                'claimReservationId',
                'Required parameter "claimReservationId" was null or undefined when calling editClaimReservation().'
            );
        }

        if (requestParameters['editClaimReservationRequest'] == null) {
            throw new runtime.RequiredError(
                'editClaimReservationRequest',
                'Required parameter "editClaimReservationRequest" was null or undefined when calling editClaimReservation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-reservations/{claimReservationId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"claimReservationId"}}`, encodeURIComponent(String(requestParameters['claimReservationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EditClaimReservationRequestToJSON(requestParameters['editClaimReservationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimReservationFromJSON(jsonValue));
    }

    /**
     * Edit a claim reservation
     */
    async editClaimReservation(requestParameters: EditClaimReservationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimReservation> {
        const response = await this.editClaimReservationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get claim center availability
     */
    async getClaimCenterAvailabilityRaw(requestParameters: GetClaimCenterAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimReservationAvailability>> {
        if (requestParameters['claimCenterId'] == null) {
            throw new runtime.RequiredError(
                'claimCenterId',
                'Required parameter "claimCenterId" was null or undefined when calling getClaimCenterAvailability().'
            );
        }

        if (requestParameters['date'] == null) {
            throw new runtime.RequiredError(
                'date',
                'Required parameter "date" was null or undefined when calling getClaimCenterAvailability().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getClaimCenterAvailability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['durationInMinutes'] != null) {
            queryParameters['durationInMinutes'] = requestParameters['durationInMinutes'];
        }

        if (requestParameters['excludeReservationId'] != null) {
            queryParameters['excludeReservationId'] = requestParameters['excludeReservationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-reservations/claim-center/{claimCenterId}/reservations/availability/{date}`;
        urlPath = urlPath.replace(`{${"claimCenterId"}}`, encodeURIComponent(String(requestParameters['claimCenterId'])));
        urlPath = urlPath.replace(`{${"date"}}`, encodeURIComponent(String(requestParameters['date'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimReservationAvailabilityFromJSON(jsonValue));
    }

    /**
     * Get claim center availability
     */
    async getClaimCenterAvailability(requestParameters: GetClaimCenterAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimReservationAvailability> {
        const response = await this.getClaimCenterAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the bookables for a claim center including their schedules for the given date.
     */
    async getClaimCenterBookablesForDateRaw(requestParameters: GetClaimCenterBookablesForDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimCenterBookables>> {
        if (requestParameters['claimCenterId'] == null) {
            throw new runtime.RequiredError(
                'claimCenterId',
                'Required parameter "claimCenterId" was null or undefined when calling getClaimCenterBookablesForDate().'
            );
        }

        if (requestParameters['date'] == null) {
            throw new runtime.RequiredError(
                'date',
                'Required parameter "date" was null or undefined when calling getClaimCenterBookablesForDate().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getClaimCenterBookablesForDate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:claim-centers"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-reservations/claim-center/{claimCenterId}/bookables/{date}`;
        urlPath = urlPath.replace(`{${"claimCenterId"}}`, encodeURIComponent(String(requestParameters['claimCenterId'])));
        urlPath = urlPath.replace(`{${"date"}}`, encodeURIComponent(String(requestParameters['date'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimCenterBookablesFromJSON(jsonValue));
    }

    /**
     * Get the bookables for a claim center including their schedules for the given date.
     */
    async getClaimCenterBookablesForDate(requestParameters: GetClaimCenterBookablesForDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimCenterBookables> {
        const response = await this.getClaimCenterBookablesForDateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the schedule exceptions for a claim center for the given date.
     */
    async getClaimCenterExceptionsForDateRaw(requestParameters: GetClaimCenterExceptionsForDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimCenterScheduleExceptions>> {
        if (requestParameters['claimCenterId'] == null) {
            throw new runtime.RequiredError(
                'claimCenterId',
                'Required parameter "claimCenterId" was null or undefined when calling getClaimCenterExceptionsForDate().'
            );
        }

        if (requestParameters['date'] == null) {
            throw new runtime.RequiredError(
                'date',
                'Required parameter "date" was null or undefined when calling getClaimCenterExceptionsForDate().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getClaimCenterExceptionsForDate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-reservations/claim-center/{claimCenterId}/exceptions/{date}`;
        urlPath = urlPath.replace(`{${"claimCenterId"}}`, encodeURIComponent(String(requestParameters['claimCenterId'])));
        urlPath = urlPath.replace(`{${"date"}}`, encodeURIComponent(String(requestParameters['date'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimCenterScheduleExceptionsFromJSON(jsonValue));
    }

    /**
     * Get the schedule exceptions for a claim center for the given date.
     */
    async getClaimCenterExceptionsForDate(requestParameters: GetClaimCenterExceptionsForDateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimCenterScheduleExceptions> {
        const response = await this.getClaimCenterExceptionsForDateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the claim center exceptions for a given date range.
     */
    async getClaimCenterExceptionsForRangeRaw(requestParameters: GetClaimCenterExceptionsForRangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimCenterScheduleExceptionsForRange>> {
        if (requestParameters['localStartDate'] == null) {
            throw new runtime.RequiredError(
                'localStartDate',
                'Required parameter "localStartDate" was null or undefined when calling getClaimCenterExceptionsForRange().'
            );
        }

        if (requestParameters['localEndDate'] == null) {
            throw new runtime.RequiredError(
                'localEndDate',
                'Required parameter "localEndDate" was null or undefined when calling getClaimCenterExceptionsForRange().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getClaimCenterExceptionsForRange().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['localStartDate'] != null) {
            queryParameters['localStartDate'] = requestParameters['localStartDate'];
        }

        if (requestParameters['localEndDate'] != null) {
            queryParameters['localEndDate'] = requestParameters['localEndDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-reservations/claim-center/exceptions`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimCenterScheduleExceptionsForRangeFromJSON(jsonValue));
    }

    /**
     * Get the claim center exceptions for a given date range.
     */
    async getClaimCenterExceptionsForRange(requestParameters: GetClaimCenterExceptionsForRangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimCenterScheduleExceptionsForRange> {
        const response = await this.getClaimCenterExceptionsForRangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get claim centers for a customer
     */
    async getClaimCentersRaw(requestParameters: GetClaimCentersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimCentersWithBookables>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getClaimCenters().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:claim-centers"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-reservations/claim-centers`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimCentersWithBookablesFromJSON(jsonValue));
    }

    /**
     * Get claim centers for a customer
     */
    async getClaimCenters(requestParameters: GetClaimCentersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimCentersWithBookables> {
        const response = await this.getClaimCentersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get claim reservations by filters
     */
    async getClaimReservationsRaw(requestParameters: GetClaimReservationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimReservations>> {
        if (requestParameters['claimCenterId'] == null) {
            throw new runtime.RequiredError(
                'claimCenterId',
                'Required parameter "claimCenterId" was null or undefined when calling getClaimReservations().'
            );
        }

        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling getClaimReservations().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling getClaimReservations().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getClaimReservations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-reservations/claim-center/{claimCenterId}/reservations`;
        urlPath = urlPath.replace(`{${"claimCenterId"}}`, encodeURIComponent(String(requestParameters['claimCenterId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimReservationsFromJSON(jsonValue));
    }

    /**
     * Get claim reservations by filters
     */
    async getClaimReservations(requestParameters: GetClaimReservationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimReservations> {
        const response = await this.getClaimReservationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Preview the impact of removing a bookable\'s schedule for a specific date. Returns which reservations can be reassigned and which must be cancelled.
     */
    async getUnschedulePreviewRaw(requestParameters: GetUnschedulePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnschedulePreviewResponse>> {
        if (requestParameters['claimCenterId'] == null) {
            throw new runtime.RequiredError(
                'claimCenterId',
                'Required parameter "claimCenterId" was null or undefined when calling getUnschedulePreview().'
            );
        }

        if (requestParameters['bookableId'] == null) {
            throw new runtime.RequiredError(
                'bookableId',
                'Required parameter "bookableId" was null or undefined when calling getUnschedulePreview().'
            );
        }

        if (requestParameters['localDate'] == null) {
            throw new runtime.RequiredError(
                'localDate',
                'Required parameter "localDate" was null or undefined when calling getUnschedulePreview().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getUnschedulePreview().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['localDate'] != null) {
            queryParameters['localDate'] = requestParameters['localDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:claim-center-schedules"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-reservations/{claimCenterId}/bookable/{bookableId}/unschedule-preview`;
        urlPath = urlPath.replace(`{${"claimCenterId"}}`, encodeURIComponent(String(requestParameters['claimCenterId'])));
        urlPath = urlPath.replace(`{${"bookableId"}}`, encodeURIComponent(String(requestParameters['bookableId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnschedulePreviewResponseFromJSON(jsonValue));
    }

    /**
     * Preview the impact of removing a bookable\'s schedule for a specific date. Returns which reservations can be reassigned and which must be cancelled.
     */
    async getUnschedulePreview(requestParameters: GetUnschedulePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnschedulePreviewResponse> {
        const response = await this.getUnschedulePreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Re-send the claim form notification to a player via SMS or email
     */
    async resendClaimFormNotificationRaw(requestParameters: ResendClaimFormNotificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResendClaimFormNotificationResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling resendClaimFormNotification().'
            );
        }

        if (requestParameters['claimReservationId'] == null) {
            throw new runtime.RequiredError(
                'claimReservationId',
                'Required parameter "claimReservationId" was null or undefined when calling resendClaimFormNotification().'
            );
        }

        if (requestParameters['resendClaimFormNotificationRequest'] == null) {
            throw new runtime.RequiredError(
                'resendClaimFormNotificationRequest',
                'Required parameter "resendClaimFormNotificationRequest" was null or undefined when calling resendClaimFormNotification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-reservations/{claimReservationId}/resend-claim-form-notification`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"claimReservationId"}}`, encodeURIComponent(String(requestParameters['claimReservationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResendClaimFormNotificationRequestToJSON(requestParameters['resendClaimFormNotificationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResendClaimFormNotificationResponseFromJSON(jsonValue));
    }

    /**
     * Re-send the claim form notification to a player via SMS or email
     */
    async resendClaimFormNotification(requestParameters: ResendClaimFormNotificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResendClaimFormNotificationResponse> {
        const response = await this.resendClaimFormNotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Schedule a bookable at a claim center for a particular day. Will attempt to find a bookable that is unscheduled for that day and add it. Errors if there are no more bookables available
     */
    async scheduleClaimCenterBookableRaw(requestParameters: ScheduleClaimCenterBookableOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimCenterBookableSchedules>> {
        if (requestParameters['claimCenterId'] == null) {
            throw new runtime.RequiredError(
                'claimCenterId',
                'Required parameter "claimCenterId" was null or undefined when calling scheduleClaimCenterBookable().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling scheduleClaimCenterBookable().'
            );
        }

        if (requestParameters['scheduleClaimCenterBookableRequest'] == null) {
            throw new runtime.RequiredError(
                'scheduleClaimCenterBookableRequest',
                'Required parameter "scheduleClaimCenterBookableRequest" was null or undefined when calling scheduleClaimCenterBookable().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:claim-center-schedules"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-reservations/{claimCenterId}/schedule/bookable`;
        urlPath = urlPath.replace(`{${"claimCenterId"}}`, encodeURIComponent(String(requestParameters['claimCenterId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ScheduleClaimCenterBookableRequestToJSON(requestParameters['scheduleClaimCenterBookableRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimCenterBookableSchedulesFromJSON(jsonValue));
    }

    /**
     * Schedule a bookable at a claim center for a particular day. Will attempt to find a bookable that is unscheduled for that day and add it. Errors if there are no more bookables available
     */
    async scheduleClaimCenterBookable(requestParameters: ScheduleClaimCenterBookableOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimCenterBookableSchedules> {
        const response = await this.scheduleClaimCenterBookableRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for claim reservations by name, phone, or email
     */
    async searchClaimReservationsRaw(requestParameters: SearchClaimReservationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageClaimReservationResponse>> {
        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling searchClaimReservations().'
            );
        }

        if (requestParameters['resultStart'] == null) {
            throw new runtime.RequiredError(
                'resultStart',
                'Required parameter "resultStart" was null or undefined when calling searchClaimReservations().'
            );
        }

        if (requestParameters['resultEnd'] == null) {
            throw new runtime.RequiredError(
                'resultEnd',
                'Required parameter "resultEnd" was null or undefined when calling searchClaimReservations().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling searchClaimReservations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['resultStart'] != null) {
            queryParameters['resultStart'] = requestParameters['resultStart'];
        }

        if (requestParameters['resultEnd'] != null) {
            queryParameters['resultEnd'] = requestParameters['resultEnd'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        if (requestParameters['claimCenterIds'] != null) {
            queryParameters['claimCenterIds'] = requestParameters['claimCenterIds'];
        }

        if (requestParameters['includeCancelled'] != null) {
            queryParameters['includeCancelled'] = requestParameters['includeCancelled'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-reservations/search`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageClaimReservationResponseFromJSON(jsonValue));
    }

    /**
     * Search for claim reservations by name, phone, or email
     */
    async searchClaimReservations(requestParameters: SearchClaimReservationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageClaimReservationResponse> {
        const response = await this.searchClaimReservationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark a claim reservation as checked in
     */
    async setClaimReservationCheckedInRaw(requestParameters: SetClaimReservationCheckedInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimReservation>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling setClaimReservationCheckedIn().'
            );
        }

        if (requestParameters['claimReservationId'] == null) {
            throw new runtime.RequiredError(
                'claimReservationId',
                'Required parameter "claimReservationId" was null or undefined when calling setClaimReservationCheckedIn().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-reservations/{claimReservationId}/checked-in`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"claimReservationId"}}`, encodeURIComponent(String(requestParameters['claimReservationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimReservationFromJSON(jsonValue));
    }

    /**
     * Mark a claim reservation as checked in
     */
    async setClaimReservationCheckedIn(requestParameters: SetClaimReservationCheckedInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimReservation> {
        const response = await this.setClaimReservationCheckedInRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark a claim reservation as no-show
     */
    async setClaimReservationNoShowRaw(requestParameters: SetClaimReservationNoShowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimReservation>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling setClaimReservationNoShow().'
            );
        }

        if (requestParameters['claimReservationId'] == null) {
            throw new runtime.RequiredError(
                'claimReservationId',
                'Required parameter "claimReservationId" was null or undefined when calling setClaimReservationNoShow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:claim-center-reservations"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-reservations/{claimReservationId}/no-show`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"claimReservationId"}}`, encodeURIComponent(String(requestParameters['claimReservationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimReservationFromJSON(jsonValue));
    }

    /**
     * Mark a claim reservation as no-show
     */
    async setClaimReservationNoShow(requestParameters: SetClaimReservationNoShowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimReservation> {
        const response = await this.setClaimReservationNoShowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a bookable\'s schedule for a specific date. Reassigns reservations where possible and cancels the rest.
     */
    async unscheduleClaimCenterBookableRaw(requestParameters: UnscheduleClaimCenterBookableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnscheduleBookableResponse>> {
        if (requestParameters['claimCenterId'] == null) {
            throw new runtime.RequiredError(
                'claimCenterId',
                'Required parameter "claimCenterId" was null or undefined when calling unscheduleClaimCenterBookable().'
            );
        }

        if (requestParameters['bookableId'] == null) {
            throw new runtime.RequiredError(
                'bookableId',
                'Required parameter "bookableId" was null or undefined when calling unscheduleClaimCenterBookable().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling unscheduleClaimCenterBookable().'
            );
        }

        if (requestParameters['unscheduleBookableRequest'] == null) {
            throw new runtime.RequiredError(
                'unscheduleBookableRequest',
                'Required parameter "unscheduleBookableRequest" was null or undefined when calling unscheduleClaimCenterBookable().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:claim-center-schedules"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/claim-reservations/{claimCenterId}/bookable/{bookableId}/unschedule`;
        urlPath = urlPath.replace(`{${"claimCenterId"}}`, encodeURIComponent(String(requestParameters['claimCenterId'])));
        urlPath = urlPath.replace(`{${"bookableId"}}`, encodeURIComponent(String(requestParameters['bookableId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: UnscheduleBookableRequestToJSON(requestParameters['unscheduleBookableRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnscheduleBookableResponseFromJSON(jsonValue));
    }

    /**
     * Remove a bookable\'s schedule for a specific date. Reassigns reservations where possible and cancels the rest.
     */
    async unscheduleClaimCenterBookable(requestParameters: UnscheduleClaimCenterBookableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnscheduleBookableResponse> {
        const response = await this.unscheduleClaimCenterBookableRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
